<template>
  <div class="container profilePage">
    <h3>Edit Profile</h3>
  </div>
</template>

<script>
import axios from "axios";
// import moment from "moment";

export default {
  data() {
    return {
      user: {}
    };
  },

  mounted() {},

  methods: {
    updateProfileImage() {
      let formData = new FormData();
      formData.append("image", "");
      axios
        .post("user/", formData)
        .then(() => {})
        .catch(() => {})
        .finally(() => {});
    }
  }
};
</script>

<style lang="scss" scoped>
.profilePage {
  background-color: #0c146144;
  padding-top: 30px;
  text-align: center;
}
</style>
